<template>
  <div id="app">
    <div class="container">
      <header-content v-if="$route.name !== 'certificate'"></header-content>
      <div class="main-content">
        <router-view></router-view>
      </div>
<!--      <main-content></main-content>-->
      <footer-content v-if="$route.name !== 'certificate'"></footer-content>
    </div>
    <back-to-top visibleoffset="500">
      <font-awesome-icon icon="arrow-circle-up" class="btn-to-top"/>
<!--      <button type="button" class="btn btn-to-top"></button>-->
    </back-to-top>
  </div>
</template>

<script>
  import Vue from 'vue'
  import headerContent from "./views/elements/headerContent"
  // import mainContent from "./views/elements/mainContent"
  import footerContent from "./views/elements/footerContent"
  import VueCountdown from '@chenfengyuan/vue-countdown';
  import BackToTop from 'vue-backtotop'
  import {library} from '@fortawesome/fontawesome-svg-core'
  import {fas} from '@fortawesome/free-solid-svg-icons'
  import {far} from '@fortawesome/free-regular-svg-icons'
  // import {fab} from '@fortawesome/free-brands-svg-icons'
  import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

  library.add(fas,far);
  Vue.component('font-awesome-icon', FontAwesomeIcon);
  import {SyncLoader} from '@saeris/vue-spinners';
  Vue.use(SyncLoader)
  Vue.use(BackToTop);
  Vue.component(VueCountdown.name, VueCountdown);


  export default {
    name: "App",
    components:{

      headerContent,
      // mainContent,
      footerContent
    },
    watch: {
      '$route' (to, from) {
        let title = 'ONiAd Academy |';
        let subTitle = ' '+to.meta.title;
        if(subTitle){
          title += subTitle;
        }
        if(to.params.slug){
          title += ' '+to.params.slug;
        }
        if (to.name !== 'certificate'){
          document.title = title;
          this.$gtag.pageview({
            page_title: title, // route name value
            page_path: to.path, // route path value
            // page_location: window.location.href
          })
        }
      }
    },
    mounted() {
      // console.log(GTM_CODE,NODE_ENV)
    }

    // methods: {
    //   setupStream() {
    //     // Not a real URL, just using for demo purposes
    //     let es = new EventSource('http://app.oniad.local:8081/prueba/5');
    //     // console.log(es)
    //
    //     es.addEventListener('message', event => {
    //       let data = JSON.parse(event.data);
    //       console.log(data)
    //     }, false);
    //     es.addEventListener('error', event => {
    //       if (event.readyState == EventSource.CLOSED) {
    //         console.log('Event was closed');
    //         console.log(EventSource);
    //       }
    //     }, false);
    //   }
    // }

  }
</script>



<style lang="scss">
  @import "styles/global";

  $main-color: rgba(50, 197, 210, 1);
  $main-color-hover: rgba(50, 197, 210, .7);


  *, ::before, ::after{
    box-sizing: border-box;
  }

  html{
    background-color: #fff;
    /*height:100%;*/
    font-size: 18px;
    -webkit-overflow-scrolling : touch;
    -webkit-tap-highlight-color : transparent;
    -webkit-text-size-adjust : 100%;
    -ms-text-size-adjust : 100%;
  }
  body {

    /*height:100%;*/
    margin: 0;
    color: #202124;
    cursor: auto;
    font-family: $basefont;
    font-size: 1em;
    font-style: normal;
    font-weight: 300;
    line-height: 1.444;
    overflow-wrap: break-word;
    word-wrap: break-word;
    h1,h2,h3,h4,h5{
      /*font-family: 'Open Sans', sans-serif;*/
      /*font-weight: 300;*/
    }
    button{
      font-family: 'Open Sans', sans-serif;
    }

    /*p{*/
    /*  font-size: 1rem;*/
    /*  line-height: 1.5;*/
    /*  letter-spacing:0;*/
    /*  font-weight: 300;*/
    /*}*/
  }
  .btn-to-top{
    opacity: 0.3;
    font-size: 3em;
    &:hover{
      opacity: 0.5;
    }
  }

  img{
    display: block;
    max-width: 100%;
  }
  .mainContent {
    display: flex;
    flex-direction: column;
    max-width: 800px;
    align-items: center;
    /*align-self: center;*/
    margin: 2em 1em 4em;
  }



  .container{
    display: grid;
    grid-template-areas:
            "header header header"
            "content content content"
            "footer footer footer";
    grid-template-columns: min-content;
    grid-template-rows: auto 1fr auto;
    grid-gap: 10px;
    grid-row-gap: 0;
    min-height: 100vh;
  }
  .header {
    grid-area: header;

    position: sticky;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1em;
    background: #fff;
    // width: 100%;
    height: 80px;
    box-shadow: 0 2px 6px 0 rgba(0,0,0,0.12),inset 0 -1px 0 0 #dadce0;
    z-index: 9;
    grid-area: header;
    .logo-menu-button{
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      .logo{
        margin: 0 1em;
        max-width: 200px;
        img{
          display: block;
          width: 100%;
        }
      }
      .menu-button{
        display: none;
        align-items: center;
        .navIcon { // Hamburguer icon closed
          display: inline-block;
          float: right;
          cursor: pointer;
          margin: 0.5em;
          .iconbar1,
          .iconbar2,
          .iconbar3 {
            display: block;
            width: 35px;
            margin: 5px 0;
            height: 5px;
            background-color: #666;
            transition: all .5s;
          }
          &.active { // hamburguer icon opened
            .iconbar1,
            .iconbar2,
            .iconbar3 {
            }
            .iconbar1 {
              transform: translate(0, 10px) rotate(45deg) ;
            }
            .iconbar2 {
              opacity: 0;
            }
            .iconbar3 {
              transform: translate(0, -10px) rotate(-45deg) ;
            }
          }
        }
        .menu-text{
          color: #666;
          font-size: 1.8em;
        }
      }
    }
  }

  .main-content{
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    grid-area: content;
    justify-content: flex-start;
    padding-top: 1em;
  }
  .temaryPage{
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    grid-area: content;
    justify-content: flex-start;
    width: 100%;
    .nav{
      grid-area: nav;
      background: white;
      min-width:200px;
      width: auto;
      height: 100%;
      /*min-height: 100vh;*/
      overflow: hidden;
      padding-right: 1em;
      max-width: 350px;

      li{
        a{
          display: block;
          margin-bottom: 0.5em;
        }
      }
      .tree-anchor {
        font-size: 0.8rem;
      }
    }
    .content{
      display: flex;
      flex-direction: column;
      margin: 0 1em;
      width: 100%;

      &.active{
        // margin-left: 300px;
      }
      .content-loaded{
        max-width: 1200px;
        margin: 0 auto 2rem;
        ul{
          padding: 0 0 0 40px;
        }
      }
      .paginator{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin: 0 auto 5rem;
        svg{
          margin: 0 0.5em;
        }

        div{
          margin: 0 0.5em;
        }
      }
    }
  }
  .pageSection{
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    >div{
      margin: 1em
    }
  }
  input[type='text'] {
    width: 100%;
  }

  textarea {
    width: 100%;
  }

  form {
    width: 100%;
  }
  .section_columns{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    max-width: 1244px;
    flex-wrap: wrap;
    /*padding: 0 50px;*/
    width: 100%;
    /*>div{*/
    /*  margin-right: 100px;*/
    /*}*/
    >div:last-child{
      margin-right: 0;
    }
    &.air-lg{
      padding: 50px 50px;
    }
    img{
      padding: 2em;
      max-width: 500px;
      min-width: 300px;
      width: 100%;
      height: auto;
    }
  }
  @media all and (max-width: 450px){
   .section_columns{
     width: auto;
     &.air-lg{
       padding: 0;
     }
   }
  }

  .form-vue{
    &.align-right{
      text-align: right;
    }

    .form-group-vue{
      margin-bottom: 0.5em;
      &.form-group-vue-horizontal{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: nowrap;
        > div{
          /*margin-left: 0.5em;*/
          margin-right: 1em;
          /*margin-bottom: 0.5em;*/
        }
        > div:first-child{
          margin-left: 0;
        }
        > div:last-child{
          margin-right: 0;
        }
      }
      &.flex-column {
        > div{
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
  @media only screen and (max-width: 1200px) {
    .section_columns{
      flex-direction: column;
      justify-content: center;
    }
    .form-vue{
      &.align-right{
        text-align: right;
      }

      .form-group-vue{
        &.form-group-vue-horizontal{
          > div{
            margin: 0 0.5em 0 0;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 600px) {
    .header{
      padding: 1em;
      flex-direction: column;
      height: auto;
      .logo-menu-button{
        justify-content: space-between;
        align-self: flex-start;
        margin-bottom: 1em;
        width: 100%;
        .logo{
          width: 100%;
          display: flex;
          justify-content: flex-end;
        }
        .menu-button {
          display: flex;
        }
      }
      .btn-certificate{
        width: 100%;
        button{
          width: 100%;
        }
      }
    }
    .main-content{
      .nav{
        position: absolute;
        top:0;
        left: 0;
        box-shadow: 0 0 4px rgba(0,0,0,.14),0 8px 4px rgba(0,0,0,.28);
      }
      .breadcrumb{display: none;}
    }
    .form-vue{
      &.align-right{
        text-align: right;
      }

      .form-group-vue{
        &.form-group-vue-horizontal{
          display: flex;
          flex-direction: column;
          > div{
            margin: 0 0 0.5em 0;
          }
        }
      }
    }

  }



  //TRANSITIONS
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: height, opacity;
    transition-timing-function: ease;
    overflow: hidden;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

  .slide-left-enter-active,
  .slide-left-leave-active,
  .slide-right-enter-active,
  .slide-right-leave-active {
    transition-duration: 1s;
    transition-property: height, opacity, transform;
    transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
    overflow: hidden;
  }

  .slide-left-enter,
  .slide-right-leave-active {
    opacity: 0;
    transform: translate(-5em, 0);
  }

  .slide-left-leave-active,
  .slide-right-enter {
    opacity: 0;
    transform: translate(-5em, 0);
  }

  .zoom-enter-active,
  .zoom-leave-active {
    animation-duration: 0.5s;
    animation-fill-mode: both;
    animation-name: zoom;
  }

  .zoom-leave-active {
    animation-direction: reverse;
  }

  @keyframes zoom {
    from {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }

    100% {
      opacity: 1;
    }
  }

</style>
